import { usePage } from "@inertiajs/vue3";

type TypeProps = {
    translations : Record<string, string>,
};

const __ = (translate_name : string) : string => {
    const translations = usePage<{props: TypeProps}>().props?.translations;

    // @ts-ignore
    return translations[translate_name] ?? '';
};

export default __;
